import { appDay } from 'shared/day'

import type { Campaign } from './types'

import { statusToColor } from './const'

const propertyToReadableDate = (value?: null | string) =>
	value ? appDay(value).format('DD MMM YYYY HH:mm') : ''

/** @deprecated */
export const transformLegacyInformation = (campaign: Campaign) => [
	{
		color: statusToColor[campaign.state],
		id: 1,
		label: 'Status:',
		pause_reason: campaign.pause_reason || '',
		value: campaign.state
	},
	{
		id: 2,
		label: 'Contacts:',
		value: campaign.target_audience_count
	},
	{
		id: 3,
		label: 'Start date:',
		value: propertyToReadableDate(campaign.started)
	},
	{
		id: 4,
		label: 'End date:',
		value: propertyToReadableDate(campaign.completed)
	}
]
